// Strict parser: /foo and /foo/ are distinct routes (no trailing-slash tolerance)
export const strictParser = (path: string, loose?: boolean): {pattern: RegExp; keys: string[]} => {
    const keys: string[] = []
    const src = path
        .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        .replace(/\\:(\w+)/g, (_, key: string) => {
            keys.push(key)
            return '([^/]+)'
        })
    return {
        pattern: new RegExp(`^${src}${loose ? '(?=/|$)' : '$'}`),
        keys
    }
}
